<ng-container *ngIf="state$ | async as state">
  <section
    *ngIf="shouldShowBanner(state)"
    class="cookie-consent-banner"
    aria-labelledby="cookie-consent-title"
  >
    <div class="cookie-consent-banner__inner site-content-container">
      <div class="cookie-consent-banner__copy">
        <h2 id="cookie-consent-title">Your privacy choices</h2>
        <p>
          CitizeX uses essential cookies to operate securely. You can choose
          whether Google Analytics, Microsoft Clarity, and Google Ads marketing
          technologies may be used.
        </p>
        <a routerLink="/cookies">Read our Cookie Policy</a>
      </div>

      <div class="cookie-consent-actions">
        <button
          type="button"
          class="cookie-action cookie-action--secondary"
          (click)="rejectOptional()"
        >
          Reject optional
        </button>
        <button
          type="button"
          class="cookie-action cookie-action--secondary"
          (click)="openPreferences($event)"
        >
          Manage preferences
        </button>
        <button
          type="button"
          class="cookie-action cookie-action--primary"
          (click)="acceptAll()"
        >
          Accept all
        </button>
      </div>
    </div>
  </section>

  <div
    *ngIf="state.isDialogOpen"
    class="cookie-dialog-backdrop"
    (click)="closePreferences()"
  >
    <section
      class="cookie-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-preferences-title"
      aria-describedby="cookie-preferences-description"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()"
      (keydown.escape)="closePreferences()"
    >
      <button
        type="button"
        class="cookie-dialog__close"
        aria-label="Close cookie preferences"
        (click)="closePreferences()"
      >
        <app-icon name="x" aria-hidden="true"></app-icon>
      </button>

      <div class="cookie-dialog__header">
        <h2 id="cookie-preferences-title">Cookie preferences</h2>
        <p id="cookie-preferences-description">
          Essential cookies are always on. Choose which optional third-party
          services you want CitizeX to use.
        </p>
      </div>

      <div class="cookie-preference-list">
        <label class="cookie-preference" for="essential-cookies">
          <span class="cookie-preference__copy">
            <strong>Essential cookies</strong>
            <span>
              These support secure sign-in, session management, fraud
              prevention, and core Platform functionality.
            </span>
          </span>
          <span class="cookie-switch">
            <input
              id="essential-cookies"
              type="checkbox"
              role="switch"
              checked
              disabled
            />
            <span class="cookie-switch__track" aria-hidden="true"></span>
          </span>
        </label>

        <label
          *ngFor="let service of optionalServices"
          class="cookie-preference"
          [for]="service.controlId"
        >
          <span class="cookie-preference__copy">
            <strong>{{ service.name }}</strong>
            <span>{{ service.description }}</span>
          </span>
          <span class="cookie-switch">
            <input
              [id]="service.controlId"
              type="checkbox"
              role="switch"
              [checked]="draft[service.preference]"
              (change)="setPreference(service.preference, $event)"
            />
            <span class="cookie-switch__track" aria-hidden="true"></span>
          </span>
        </label>
      </div>

      <p class="cookie-dialog__storage-note">
        Your choices are saved only in this browser.
      </p>

      <div class="cookie-dialog__actions">
        <button
          type="button"
          class="cookie-action cookie-action--primary"
          (click)="savePreferences()"
        >
          Save preferences
        </button>
        <button
          type="button"
          class="cookie-action cookie-action--secondary"
          (click)="acceptAll()"
        >
          Accept all
        </button>
        <button
          type="button"
          class="cookie-action cookie-action--secondary"
          (click)="rejectOptional()"
        >
          Reject optional
        </button>
      </div>
    </section>
  </div>
</ng-container>
